import { apiClient } from "@/services/api-client";

export const getBlogListDataApi = (queryString) => {
  return apiClient({
    url: `/v1/articles${queryString ? queryString : ""}`,
    method: "GET",
  });
};

export const getBlogApi = async (blog_slug) => {
  return await apiClient({
    url: `/v1/articles/${blog_slug}`,
    method: "GET",
  });
};
